import script from "./LicenseContents.vue?vue&type=script&setup=true&lang=ts"
export * from "./LicenseContents.vue?vue&type=script&setup=true&lang=ts"

import "./LicenseContents.vue?vue&type=style&index=0&id=5f06eb14&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f06eb14"]])

export default __exports__